export function sendErrorToInstana(errorInfo = "", error = "", opts = {}) {
    if (window.ineum && typeof window.ineum === "function") {
        window.ineum(`(TRACKED/HANDLED ERROR) ${errorInfo}`, error, opts);
    }
}